<template>
  <div>
    <common-dialog
      ref="dialog"
      width="850px"
      show-save-button
      unit="PDA配置"
      edit-title
      id-key="PdaDeviceId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备名称" prop="PdaDeviceName">
              <el-input v-model="data.PdaDeviceName" placeholder="请输设备名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备编码" prop="PdaDeviceNo">
              <el-input v-model="data.PdaDeviceNo" placeholder="请输设备编码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-select v-model="data.Status">
                <el-option label="在用" :value="2"></el-option>
                <el-option label="停用" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="绑定类型" prop="TypeId">
              <el-select v-model="data.TypeId">
                <el-option label="部门" :value="1"></el-option>
                <el-option label="加工单元" :value="2"></el-option>
                <el-option label="用户" :value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="data.TypeId === 1">
            <el-form-item label="绑定部门" prop="DpId">
              <dp-select ref="dpSelect" v-model="data.DpId" />
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="data.TypeId === 3">
            <el-form-item label="绑定用户" prop="EmpId">
              <select-input placeholder="选择用户" :label="data.EmpName" v-model="data.EmpId" @click="openEmpDialog" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12" v-if="data.TypeId === 2">
            <el-form-item label="绑定加工单元" prop="ProcessUnitId" label-width="120px">
              <el-select v-model="data.ProcessUnitId" clearable>
                <el-option v-for="item in teProcessUnitList" :key="item.ProcessUnitId" :value="item.ProcessUnitId" :label="item.ProcessUnitName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import invoiceSelect from '@/components/basedata/basedoc/billtype/select'
import dpSelect from '@/components/production/clothmanagement/cloth/workorder/dpSelect'
import empDialog from '@/components/personnel/result/record/listDialog'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    invoiceSelect,
    dpSelect,
    empDialog
  },
  data() {
    return {
      data: {
        PdaDeviceId: 0,
        PdaDeviceName: null,
        PdaDeviceNo: null,
        Status: 2,
        DpId: null,
        TypeId: null,
        ProcessUnitId: null,
        EmpId: null,
        EmpName: null
      },
      formApi: require('@/api/sy/formSetting').default,
      api: require('@/api/ba/pdaDevice').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      teProcessUnitApi: require('@/api/production/teProcessUnit').default,
      // trendData: iForm.Data,
      showList: [],
      machiningStageList: [],
      teProcessUnitList: [],
      rules: {
        PdaDeviceName: [{ required: true, message: '请输入设备名称' }],
        PdaDeviceNo: [{ required: true, message: '请输入设备编码' }],
        TypeId: [{ required: true, message: '请输入绑定类型' }]
      },
    }
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {
      let modeName = this.urlHash ? this.urlHash.split('/').join('') : location.hash.split('/').slice(1).join('')
      this.formApi.list({ type: modeName }).then(res => {
        this.showList = res.Data?.map(x => x.ShowField)
      })

      this.machiningStageApi.list({ Status: 1 }).then(res => {
        this.machiningStageList = res.Data
      })
      this.teProcessUnitApi.list({ Status: 1 }).then(res => {
        this.teProcessUnitList = res.Data
      })
    },
    //判断显示
    iShow(data) {
      if (this.showList == null || this.showList.length === 0) return true
      return this.showList.indexOf(data) !== -1 ? true : false
    },
    onCreateOpened(data) {
      
      this.data.PdaDeviceId = 0
      this.data.PdaDeviceName = null
      this.data.PdaDeviceNo = null
      this.data.Status = 2
      this.data.DpId = null
      this.data.TypeId = null
      this.data.ProcessUnitId = null
      this.data.EmpId = null

      if(this.$refs.dpSelect)
      this.$refs.dpSelect.clear()
    },
    onEditOpened(data) {
    console.log("🚀 ~ data:", data)
    },
    onClosed() {
      this.showList = []
    },
    openEmpDialog() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    setEmp(emp) {
      this.data.EmpId = emp.EmpId
      this.data.EmpName = emp.EmpName
      this.data.DpId = emp.DpId
      this.data.DpName = emp.DpName
    },
    onBeforeSave(){
      if(this.data.TypeId == 1 && !this.data.DpId){
        this.$message.error('请选择部门')
        return false
      }else if(this.data.TypeId == 2 && !this.data.ProcessUnitId){
        this.$message.error('请选择加工单元')
        return false
      }else if(this.data.TypeId == 3 && !this.data.EmpId){
        this.$message.error('请选择用户')
        return false
      }
      return true 
    }
  }
}
</script>
